import { useQuery } from '@/client/context/query'
import { useUser } from '@/client/context/user'

import type { SATBootcampTutorOnboardingState } from '../../types'
import satBootcampTutorOnboardingStateFromQuery from './satBootcampTutorOnboardingStateFromQuery'

export default function useSATBootcampTutorOnboardingState(): SATBootcampTutorOnboardingState {
  const query = useQuery()
  const user = useUser()

  return satBootcampTutorOnboardingStateFromQuery({ query, user })
}
